import { ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { FiltersM } from '../../../components/models';
import { DataService } from '../../../services/data/data.service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { cuentaEntity, detalleCuentaEntity, evaluacionesAllEntity, sucursalesEntity, varTipoEntity } from '../../../services/segimiento-presupuestal/Manual/entities';
import { SegPresupuestalService } from '../../../services/segimiento-presupuestal/seg-presupuestal.service';
import { companiesSegPresupuestal } from '../../../shared/catalogos';
import { messages } from '../../funciones/mensajes';
import { obtenerIds } from '../idsTabla';
import { Periodos } from '../funcionesFormuladorSeguimiento';

@Component({
  selector: 'app-catalogo-cuentas',
  templateUrl: './catalogo-cuentas.component.html',
  styleUrl: './catalogo-cuentas.component.css'
})
export class CatalogoCuentasComponent {
  public Filters = FiltersM;
  public escenarios: any[] = [];
  public escenariosShow: any[] = [];
  public todosEscenarios: boolean = true;
  public escenarioSeleccionado;

  public sucursales: any[] = [];
  public consolidado: boolean = true;
  public sucursalSeleccionada;
  private institucionId = undefined;
  private templateId = undefined;
  private idBase: number;
  public tagInstitucion: number;
  public miles = ',';
  public decimal = '.';
  // Propiedades para períodos
  public Periodos: any[] = [];
  public periodoSeleccionado: any = null;
  public periodosEnc = '';
  public periodosData = [];
  private maxPeriodos: number = 6;

  public dataCuentaContable: any[] = [];
  public cuentaSelec = undefined;
  public cuentasVisibles: any[] = [];
  public contraerExpandir: boolean =  false; //false -> contraer todo   true -> expandir todo
  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    public cookies: CookieService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,
    private segPresupuestalService: SegPresupuestalService,
  ) {
    this.institucionId = this.cookies.get('idInstitucion');
    this.idBase = companiesSegPresupuestal.find(i => i.id == this.institucionId).idBack;
    this.personalizacion();
    this.initEscenarios();    
    this.initSucursales();
  }

  private personalizacion(){
    this.tagInstitucion = companiesSegPresupuestal.find( i => i.id == this.institucionId).etiquetas;
  }
  
  private async getCuentasContables() {
    if (!this.templateId) {
      this.dataCuentaContable = [];
      return;
    }
    this.cuentasVisibles = [];
    try {
      //DESCRIPCIONES
      let cuentaDesc: cuentaEntity = {plantillaId: this.templateId}
      let res: any = await firstValueFrom(this.segPresupuestalService.getCuentasDescripcion(cuentaDesc));
      let varsEntity: varTipoEntity = {plantillaId: this.templateId, tipoVariableId: 3} // 3 es por que representa las variables temporales
      const varsDesc = await firstValueFrom(this.segPresupuestalService.getVariableTipoDescripcion(varsEntity));
      res = [...res, ...varsDesc];
      //VALORES
      let valores = [];
      let valoresVars = [];
      let cuentaValor: detalleCuentaEntity;
      if(this.escenarioSeleccionado.name == 'Ejecutado'){ // se van a consultar los valores ejecutados de las evaluaciones 
        for(let i = 0; i < this.periodosData.length; i++){
          cuentaValor = {idEvaluacion: this.periodosData[i].idReal}
          const r = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
          valores.push(r.data.detalleEvaluacionCuentas);
          varsEntity = {tipoVariableId: 3, evaluacionId: this.periodosData[i].idReal};
          const vars = await firstValueFrom(this.segPresupuestalService.getVariableTipoValor(varsEntity));
          valoresVars.push(vars)
        }
      }else{ //Consultamos los valores asociados al escenario seleccionado
        const idEsce = this.escenariosShow.find(e => e.check);
        for(let i = 0; i < this.periodosData.length; i++){
          const e = this.periodosData[i].idPresupuesto.findIndex( p => p.institucionId == idEsce.id);
          cuentaValor = {idEvaluacion: this.periodosData[i].idPresupuesto[e].id}
          const r = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
          valores.push(r.data.detalleEvaluacionCuentas);
          varsEntity = {tipoVariableId: 3, evaluacionId: this.periodosData[i].idPresupuesto[e].id};
          const vars = await firstValueFrom(this.segPresupuestalService.getVariableTipoValor(varsEntity));
          valoresVars.push(vars)
        }
      }
      let dataValores = valores[0].map((_,i) => 
        valores.map(arr => arr[i]));
      let dataVR = valoresVars[0].map((_,i) => 
        valoresVars.map(arr => arr[i]));
      dataValores = [...dataValores, ...dataVR];
      if (!res || res.length === 0) {
        this.dataCuentaContable = [];
        return;
      }
      this.dataCuentaContable = res.map((r: any, i) => {
        let data = dataValores[i];
        
        return {
          id: r.id,
          codigo: r.code,
          nombre: r.cuenta ?? r.variable,
          nivel: 0,
          cuentaPadre: r.cuentaPadreId ?? -1,
          hijos: [],
          expandido: false,
          visible: true,
          datos: data
        };
      });
      this.organizarJerarquia();
      this.cuentaSelec = this.cuentasVisibles[0];
    } catch (e) {
      messages.errorMessageGraph(e);
    }
  }
  private organizarJerarquia() {
     const mapaCuentas = new Map<number, any>();
    const cuentasRaiz: any[] = [];

    // Inicializa propiedades y llena el mapaCuentas
    this.dataCuentaContable.forEach(cuenta => {
      cuenta.hijos = [];
      cuenta.nivel = 0;
      cuenta.expandido = false;
      cuenta.visible = true;

      mapaCuentas.set(cuenta.id, cuenta);
    });

    // Construir la relación padre -> hijos
    this.dataCuentaContable.forEach(cuenta => {

      if (cuenta.cuentaPadre === -1) {
        // Es una cuenta raíz
        cuentasRaiz.push(cuenta);
        return;
      }

      const padre = mapaCuentas.get(cuenta.cuentaPadre);

      if (padre) {
        padre.hijos.push(cuenta);
      } else {
        // Si por alguna razón no existe el padre, la tratamos como raíz
        cuentasRaiz.push(cuenta);
      }

    });

    // Asignar niveles recursivamente
    const asignarNivel = (cuenta: any, nivel: number) => {

      cuenta.nivel = nivel;

      cuenta.hijos.forEach(hijo => {
        hijo.visible = false;
        asignarNivel(hijo, nivel + 1);
      });

    };

    cuentasRaiz.forEach(cuenta => asignarNivel(cuenta, 1));

    // Si deseas que las raíces aparezcan ordenadas
    cuentasRaiz.sort((a, b) => a.codigo.localeCompare(b.codigo));

    this.dataCuentaContable = cuentasRaiz;
    this.expandirTodo();
  }
  private expandirTodo() {
    const recorrer = (cuentas:any[]) => {
      cuentas.forEach(cuenta => {
        cuenta.expandido = true;
        if(cuenta.nivel > 2){
          recorrer(cuenta.hijos);
        }
      });
    }
    recorrer(this.dataCuentaContable);
    this.actualizarCuentasVisibles();
  } 

  private async actualizarCuentasVisibles() {
    var plantilla = '';
    if(this.templateId === 4){
      plantilla = 'idsCuentasP4';
    }
    this.cuentasVisibles = [];
    const recorrer = (cuentas: any[]) => {
      cuentas.forEach(cuenta => {
        this.cuentasVisibles.push(cuenta);
        if (cuenta.expandido && cuenta.hijos.length > 0) {
          recorrer(cuenta.hijos);
        } 
      });
    };
    await recorrer(this.dataCuentaContable);
  }
  private async initEscenarios() {
    try{
      //TODO: Hay que verificar el funcionamiento de las sucursales.
      let sucursalEntity: sucursalesEntity = {agrupadorId: this.idBase, tipoInstitucionId: 3};
      let res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.escenarios = res.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        check: false,
        ...rest
      }))
      this.escenarios[0].check = true;
      this.escenarioSeleccionado = this.escenarios[0];
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }    
  }

  private async initSucursales() {
    try{
      let res = [];
      let sucursalEntity: sucursalesEntity =  {id: this.idBase};
      const matriz = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.templateId = matriz[0].plantillaId;
      let consolidado = {name: 'Consolidado', consolidado: true, check: true, id: this.idBase};
      this.sucursales.push(consolidado)
      sucursalEntity = {agrupadorId: this.idBase, tipoInstitucionId: 5};
      res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      const resFiltro = res.filter(i => ((i.acronimo).toLowerCase()).includes('real'));
      const resEsce = res.filter(i => ((i.acronimo).toLowerCase()).includes('presupuesto'));
      const s = new Set();
      const sucur = resFiltro.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        consolidado: false,
        check: false,
        ...rest,
      })).filter( i => {
        if(s.has(i.name))
          return false;
        s.add(i.name);
        return true;
      });
      this.sucursales.push(... sucur);
      for(const suc of this.sucursales){
        if(suc.consolidado){
          suc['instEsce'] = this.escenarios;
        }else{
          const nombreSucursal = suc.name.trim().toLowerCase();

          suc.instEsce = resEsce.filter(item =>
            item.institucion.toLowerCase().includes(nombreSucursal)
          );
        }        
      }
      this.sucursalSeleccionada = this.sucursales[0];
      this.initPeriodos();
    }catch(e){
      console.warn(e)
      messages.errorMessageGraph(e.error);
    }
  }

  private async initPeriodos() {
    try{
      let evaluaciones: evaluacionesAllEntity = {plantillaId: this.templateId, institucionId: this.sucursalSeleccionada.id};
      const evaReal = await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      const evaEsce = [];
      //Buscamos las evaluaciones para cada escenario 
      for(const esce of this.sucursalSeleccionada.instEsce){
        evaluaciones = {plantillaId: this.templateId, institucionId: esce.id};
        const data = await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones))
        evaEsce.push(data)
      }
      const info = Periodos.evaluacionesPresupuestoReal(evaReal, evaEsce);
      
      this.Periodos = info.periodos;
      this.periodoSeleccionado = info.perSeleccionado;
      const periodos = (this.Periodos.find(a => a.series.find(m => m.check))).series;
      const indiceCheck = periodos.findIndex(p => p.check);
      const ultimosPeriodos = indiceCheck === -1
        ? []
        : periodos.slice(Math.max(0, indiceCheck - (this.maxPeriodos-1)), indiceCheck + 1);
      this.periodosData = ultimosPeriodos;
      this.periodosData.forEach(periodo => {
        periodo.check = true;
      });
      evaluaciones = {plantillaId: this.templateId, periodo: this.periodoSeleccionado.periodo};
      const escenarioDis =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      this.escenariosShow = escenarioDis.filter(e => e.institucionId !== this.sucursalSeleccionada.id && e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id)
        .map((e, i) => {
          return {
            name: e.institucion_entity.institucion.split(' | ')[1],
            check: false,
            idPresupuesto: e.id,
            ...e.institucion_entity
          }
        });
      const ejecutado = [{
        name: 'Ejecutado',
        idPresuesto: this.periodoSeleccionado.idReal,
        check: true
      }];
      this.escenariosShow = [...ejecutado, ...this.escenariosShow]
      this.escenarioSeleccionado = this.escenariosShow[0];
      this.getCuentasContables();
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }

  public async cambioPeriodo(per: any) {
    if (!per?.mes || !per?.anio) return;

    // Periodos actualmente seleccionados
    const seleccionados = this.Periodos.flatMap(p => p.series ?? [])
      .filter(mes => mes.check);

    // ¿El periodo que seleccionó ya estaba marcado?
    const yaSeleccionado = seleccionados.some(mes =>
      mes.mes === per.mes &&
      mes.anio === per.anio
    );

    // Año de los periodos actualmente seleccionados
    const anioActual = seleccionados.length
      ? seleccionados[0].anio
      : null;

    // =========================================================
    // 1. CAMBIÓ DE AÑO
    // =========================================================
    if (anioActual !== null && anioActual !== per.anio) {

      // Buscar el año al que pertenece el periodo seleccionado
      const nuevoAnio = this.Periodos.find(p =>
        p.series?.some(mes =>
          mes.mes === per.mes &&
          mes.anio === per.anio
        )
      );

      if (!nuevoAnio?.series) return;

      const indiceSeleccionado = nuevoAnio.series.findIndex(mes =>
        mes.mes === per.mes &&
        mes.anio === per.anio
      );

      if (indiceSeleccionado === -1) return;

      // Limpiar todos los periodos
      this.Periodos.forEach(p => {
        p.series?.forEach(mes => {
          mes.check = false;
        });
      });

      // Seleccionar máximo 6 hacia atrás
      const inicio = Math.max(0, indiceSeleccionado - (this.maxPeriodos-1));

      nuevoAnio.series
        .slice(inicio, indiceSeleccionado + 1)
        .forEach(mes => {
          mes.check = true;
        });

    }

    // =========================================================
    // 2. MISMO AÑO
    // =========================================================
    else {

      // Si ya estaba seleccionado, lo quitamos
      if (yaSeleccionado) {

        const periodo = this.Periodos
          .flatMap(p => p.series ?? [])
          .find(mes =>
            mes.mes === per.mes &&
            mes.anio === per.anio
          );

        if (periodo) {
          periodo.check = false;
        }

      }

      // Si no estaba seleccionado, intentamos agregarlo
      else {

        if (seleccionados.length >= this.maxPeriodos) {
          messages.infoMessageGraph(`No se pueden seleccionar más de ${this.maxPeriodos} periodos`)
          return;
        }

        const periodo = this.Periodos
          .flatMap(p => p.series ?? [])
          .find(mes =>
            mes.mes === per.mes &&
            mes.anio === per.anio
          );

        if (periodo) {
          periodo.check = true;
        }
      }
    }
    this.periodosData = this.Periodos
      .flatMap(p => p.series ?? [])
      .filter(mes => mes.check);
    // Periodo que disparó el cambio
    this.periodoSeleccionado = per;

    // =========================================================
    // TU LÓGICA ACTUAL
    // =========================================================

    const evaluaciones = {
      plantillaId: this.templateId,
      periodo: this.periodoSeleccionado.periodo
    };

    const escenarioDis = await firstValueFrom(
      this.segPresupuestalService.getPeriodosAll(evaluaciones)
    );

    const eseneriosAMost = escenarioDis
      .filter(e =>
        e.institucionId !== this.sucursalSeleccionada.id &&
        e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id
      )
      .map((e, i) => {
        return {
          name: e.institucion_entity.institucion.split(' | ')[1],
          check: i === 0,
          idPresupuesto: e.id,
          ...e.institucion_entity
        };
      });

    const iguales =
      eseneriosAMost.length === this.escenariosShow.length &&
      eseneriosAMost.every(
        (item, i) => item.name === this.escenariosShow[i].name
      );

    if (!iguales) {
      const ejecutado = [{
        name: 'Ejecutado',
        idPresuesto: this.periodoSeleccionado.idReal,
        check: true
      }];
      this.escenariosShow = [...ejecutado, ...eseneriosAMost];
      this.escenariosShow.forEach((e, i) => {
        if(i == 0) 
          e.check = true;
        else
          e.check = false;
      })
      this.escenarioSeleccionado = this.escenariosShow[0];
    } else {
      this.escenariosShow.forEach(e => {
        const es = eseneriosAMost.find(ee => ee.name === e.name);
        e.idPresupuesto = es?.idPresupuesto ?? e.idPresupuesto;
      });
    }

    this.getCuentasContables();
  }

  public escenarioChange(escClick: any) {
    if (!escClick || !escClick.name) return;

    this.escenariosShow.forEach(e => e.check = (e.name === escClick.name));
    const seleccionado = this.escenariosShow.find(e => e.check);
    this.escenarioSeleccionado = seleccionado;
    this.getCuentasContables();
  }

  //Metodo para la expansion y contraccion de todas las cuentas.
  public contraerExpandirTodo(){
    this.contraerExpandir = !this.contraerExpandir;

    const recorrer = (cuentas:any[]) => {
      cuentas.forEach(cuenta => {
        cuenta.expandido = this.contraerExpandir;
        recorrer(cuenta.hijos);
      });
    }
    recorrer(this.cuentasVisibles);
    this.actualizarCuentasVisibles();
  }
  public toggleExpansion(cuenta: any) {
      cuenta.expandido = !cuenta.expandido;
      this.actualizarCuentasVisibles();
  }

  public getIndentacion(cuenta: any): string {
    if(cuenta.nivel == 1){
      return '10px'
    }else{
      return `${((cuenta.nivel - 1) * 20)+10}px`;
    }
  }

  public async sucursalChange(sucClick: any) {
    for (const suc of this.sucursales) {
      if (suc.name === sucClick.name) {
        suc.check = true;
      }else{
        suc.check = false;
      }
    }

    if (sucClick.name === 'Consolidado') {
      this.consolidado = true;
    }else{
      this.consolidado = false;
    }
    this.sucursalSeleccionada = sucClick;
    this.initPeriodos();
  }

  public exportarTabla(){
    var titulos = [
      this.translate.instant('segPresupuestal.catalogoCuentas.titTab1'),
      this.translate.instant('segPresupuestal.catalogoCuentas.titTab2'),
    ];
    var mesesTxt = '';
    for(let p of this.periodosData){
      titulos.push(p.nombre);
      mesesTxt += ` | ${p.nombre}`;
    }

    var tituloHoja = this.translate.instant('segPresupuestal.catalogoCuentas.cuentas') + mesesTxt;
    var nombreArch = this.translate.instant('segPresupuestal.catalogoCuentas.nombreArch');
    this.excelService.generateCatalogoCuentas(tituloHoja, titulos, this.cuentasVisibles, nombreArch, this.escenarioSeleccionado.name == 'Ejecutado');
  }
}
